<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
    <!--app-header-->
    <app-header></app-header>
    <app-menu></app-menu>
    <!--app-body-->
    <div class="body">
        <c-container fluid class="p-0">
            <router-outlet />
        </c-container>
    </div>
    <!-- Alerts -->
    <lib-toastify-toast-container></lib-toastify-toast-container>
    <!--app footer-->
    <app-footer></app-footer>
</div>